module.exports = __webpack_public_path__ + "static/nipcbestfriends2-c1099f7c0e3ee3e47ddd089491fd0d20.jpeg";